import { useEffect, useState } from "react";

const COLORS = ["#FF6B35", "#FFB800", "#2EC4B6", "#8338EC", "#FF477E", "#2D1B2D"];

export default function Confetti({ show, count = 60 }) {
  const [pieces, setPieces] = useState([]);
  useEffect(() => {
    if (!show) return;
    const items = Array.from({ length: count }, (_, i) => ({
      id: i + "-" + Date.now(),
      left: Math.random() * 100,
      bg: COLORS[Math.floor(Math.random() * COLORS.length)],
      delay: Math.random() * 0.6,
      dur: 1.8 + Math.random() * 1.6,
      rot: Math.random() * 360,
    }));
    setPieces(items);
    const t = setTimeout(() => setPieces([]), 3200);
    return () => clearTimeout(t);
  }, [show, count]);
  return (
    <div data-testid="confetti" aria-hidden className="pointer-events-none">
      {pieces.map((p) => (
        <span
          key={p.id}
          className="confetti-piece"
          style={{
            left: `${p.left}vw`,
            background: p.bg,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.dur}s`,
            transform: `rotate(${p.rot}deg)`,
          }}
        />
      ))}
    </div>
  );
}
